export var PermissionProviderCategory;
(function (PermissionProviderCategory) {
    PermissionProviderCategory["PERMISSION_PROVIDER_CATEGORY_CLOUD_PLATFORM"] = "CLOUD_PLATFORM";
    PermissionProviderCategory["PERMISSION_PROVIDER_CATEGORY_SAAS"] = "SAAS";
    PermissionProviderCategory["PERMISSION_PROVIDER_CATEGORY_STORAGE_GATEWAY"] = "STORAGE_GATEWAY";
})(PermissionProviderCategory || (PermissionProviderCategory = {}));
